namespace Matrix.Administration {

    @Serenity.Decorators.registerClass()
    export class UserGrid extends SiteEntityGrid<UserRow, any> {
        protected getColumnsKey() { return UserColumns.columnsKey; }
        protected getDialogType() { return UserDialog; }
        protected getIdProperty() { return UserRow.idProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getService() { return UserService.baseUrl; }
        protected getIsActiveProperty() { return UserRow.Fields.IsActive; }

        constructor(container: JQuery) {
            super(container);

            if (!Authorization.userDefinition.CanAddDeleteUsers)
                this.toolbar.findButton('add-button').hide();
        }

        protected getColumns() {
            var columns = super.getColumns();

            var roleNames = Q.tryFirst(columns, x => x.field == UserRow.Fields.RoleNames);
            if (roleNames) {
                roleNames.format = ctx => {
                    var roleNames = (ctx.value || []).map(x => (RoleRow.getLookup().itemById[x] || {}).RoleName || "");
                    roleNames.sort();
                    return roleNames.join(", ");
                };
            }

            var groupRoles = Q.tryFirst(columns, x => x.field == UserRow.Fields.GroupRoles);
            if (groupRoles && roleNames)
                groupRoles.format = roleNames.format;

            var groups = Q.tryFirst(columns, x => x.field == UserRow.Fields.Groups);
            if (groups) {
                groups.format = ctx => {
                    var groupNames = (ctx.value || []).map(x => (GroupRow.getLookup().itemById[x] || {}).Name || "");
                    groupNames.sort();
                    return groupNames.join(", ");
                };
            }

            return columns;
        }

        protected getDefaultSortBy() {
            return [UserRow.Fields.Email];
        }
    }
}